import Vue from 'vue'
import Router from 'vue-router'
// import IndexPage from '@/views/index.vue'
// import ListPage from '@/views/list.vue'
// import LivePage from '@/views/live.vue'
const IndexPage = r => require.ensure([], () => r(require('@/views/index')), 'index')
const ListPage = r => require.ensure([], () => r(require('@/views/list')), 'list')
const LivePage = r => require.ensure([], () => r(require('@/views/live')), 'live')
const DownLoad = r=> require.ensure([], () => r(require('@/views/download')), 'download')
const pinkProtocol = r=> require.ensure([], () => r(require('@/views/PinkProtocol')), 'pinkProtocol')
const PayPage = r=> require.ensure([], () => r(require('@/views/pay')), 'Pay')
const Provision = r => require.ensure([], () => r(require('@/views/provision')), 'Provision')
const Policy = r => require.ensure([], () => r(require('@/views/policy')), 'Policy')
const Profile = r => require.ensure([], () => r(require('@/views/profile')), 'Profile')
const Contact = r => require.ensure([], () => r(require('@/views/contact')), 'Contact')
const PaySucc = r => require.ensure([], () => r(require('@/views/PaySucc')), 'PaySucc')
const Sdk = r => require.ensure([], () => r(require('@/views/Sdk')), 'Sdk')
const ServiceProvision = r => require.ensure([], () => r(require('@/views/service_provision')), 'ServiceProvision')
const AppProtocol = r => require.ensure([], () => r(require('@/views/appProtocol')), 'AppProtocol')
const RechargeAgreement = r => require.ensure([], () => r(require('@/views/recharge_agreement')), 'RechargeAgreement')

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/index',
      name: 'index',
      component: IndexPage
    },
    {
      path: '/list',
      name: 'list',
      component:ListPage
    },
    {
      path: '/live/:id',
      name: 'live',
      component:LivePage
    },
    {
      path: '/provision',
      name: 'Provision',
      component:Provision
    },
    {
      path: '/contact',
      name: 'Contact',
      component:Contact
    },
    {
      path: '/profile',
      name: 'Profile',
      component:Profile
    },
    {
      path: '/policy',
      name: 'Policy',
      component:Policy
    },
    {
      path: '/paysucc',
      name: 'PaySucc',
      component:PaySucc
    },
    {
      path: '/sdk',
      name: 'Sdk',
      component:Sdk
    },
    {
      path:'*',
      redirect:'/index'
    },
    {
      path: '/download',
      name: 'DownLoad',
      component:DownLoad
    },
    {
      path: '/pinkProtocol',
      name: 'PinkProtocol',
      component:pinkProtocol
    },
    {
      path: '/service_provision',
      name: 'ServiceProvision',
      component: ServiceProvision
    },
    {
      path: '/appProtocol',
      name: 'AppProtocol',
      component: AppProtocol
    },
    {
      path: '/recharge_agreement',
      name: 'RechargeAgreement',
      component: RechargeAgreement
    },
    {
      path: '/pay',
      name: 'Pay',
      component:PayPage
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
